import React, { useState } from 'react';
import {
  Input,
  Label,
  Select,
  SelectOption,
  RadioGroup,
  RadioButton,
  Checkbox,
} from '@americanexpress/dls-react';
import {
  validateInputs,
  validateField,
} from '../../validators/vendorIntakeFormValidator';
import MousePopover from '../Util/UIComp/MouseHover';
import * as LABELCONST from '../../constants/constFileLabelsVendor';
import { CHECKBOX_ERROR_MESSAGE } from '../../constants/constFileLabelsVendor';
import { isCountryChinaOrJapan } from '../../helper/functions';

// TODO: Fix ESLint errors.
const SupplierContactInfo = (props) => {
  const {
    formData,
    setFormData,
    staticData,
    page,
    formErrors,
    setFormErrors,
    isNextClicked,
  } = props;
  return (
    <form className="margin-responsive fade-in">
      <div>
        <h1 className="header-text">
          {LABELCONST.SUPPLIER_CONTACT_INFORMATION}
        </h1>
        <div className="new-line" />
        <span>Please input your contact information. *Required fields.</span>
        <div className="new-line" />
      </div>
      <div className="container pull-left-4">
        <div className="left-side">
          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.REGION} <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={LABELCONST.REGION}
              textValue={
                'Select the geographical region where the supplier needs to be created.'
              }
            />
          </div>
          <Select
            id="region"
            className="min-width-100"
            value={`${formData.region.RegionCode}:${formData.region.RegionName}`}
            onChange={(event) => {
              setFormData({
                ...formData,
                region: {
                  RegionCode: event.target.value.substring(
                    0,
                    event.target.value.indexOf(':')
                  ),
                  RegionName: event.target.value.substring(
                    event.target.value.indexOf(':') + 1
                  ),
                },
              });
              setFormErrors({
                ...formErrors,
                region: validateField(event.target.value, 'required', `Region`),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                region: validateField(
                  formData.region.RegionCode,
                  'required',
                  `Region`
                ),
              })
            }
          >
            <SelectOption value="" />
            {staticData.regions?.map((field) => (
              <SelectOption
                key={field.RegionCode}
                value={`${field.RegionCode}:${field.RegionName}`}
              >
                {field.RegionName}
              </SelectOption>
            ))}
          </Select>
          <p className="dls-red">{formErrors.region}</p>

          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.BILLING_COUNTRY} <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={LABELCONST.BILLING_COUNTRY}
              textValue={
                "Select the country in which the invoice will be billed. In case the country is not listed, then select the option as 'Other' and provide the details."
              }
            />
          </div>
          <Select
            id="billingCountry"
            className="min-width-100"
            value={`${formData.billingCountry.CountryCode}:${formData.billingCountry.CountryName}`}
            onChange={(event) => {
              setFormErrors({
                ...formErrors,
                billingCountry: validateField(
                  event.target.value,
                  'required',
                  `Billing Country`
                ),
              });
              setFormData({
                ...formData,
                billingCountry: {
                  CountryCode: event.target.value.substring(
                    0,
                    event.target.value.indexOf(':')
                  ),
                  CountryName: event.target.value.substring(
                    event.target.value.indexOf(':') + 1
                  ),
                },
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                billingCountry: validateField(
                  formData.billingCountry.CountryName,
                  'required',
                  `Billing Country`
                ),
              })
            }
          >
            <SelectOption value="" />
            {staticData.regionCountries?.map((field) => (
              <SelectOption
                key={field.id}
                data-label={field.CountryCode}
                value={`${field.CountryCode}:${field.CountryName}`}
              >
                {field.CountryName}
              </SelectOption>
            ))}
          </Select>
          {formData.billingCountry.CountryName.toLowerCase() === 'other' && (
            <div>
              <Input
                id="otherCountry"
                maxLength={50}
                value={formData.otherCountry}
                onChange={(event) => {
                  setFormErrors({
                    ...formErrors,
                    otherCountry: validateField(
                      event.target.value,
                      'required',
                      `Other Country`
                    ),
                  });
                  setFormData({
                    ...formData,
                    otherCountry: event.target.value,
                  });
                }}
                onBlur={() =>
                  setFormErrors({
                    ...formErrors,
                    otherCountry: validateField(
                      formData.otherCountry,
                      'required',
                      `Other Country`
                    ),
                  })
                }
              />
              <p className="dls-red">{formErrors.otherCountry}</p>
            </div>
          )}
          <p className="dls-red">{formErrors.billingCountry}</p>

          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.BILLING_CURRENCY} <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={LABELCONST.BILLING_CURRENCY}
              textValue={'Select the currency to be used for payment.'}
            />
          </div>
          <Select
            id="billingCurrency"
            className="min-width-100"
            value={`${formData.billingCurrency.CurrencyCode}:${formData.billingCurrency.CurrencyName}`}
            onChange={(event) => {
              setFormData({
                ...formData,
                billingCurrency: {
                  CurrencyCode: event.target.value.substring(
                    0,
                    event.target.value.indexOf(':')
                  ),
                  CurrencyName: event.target.value.substring(
                    event.target.value.indexOf(':') + 1
                  ),
                },
              });
              setFormErrors({
                ...formErrors,
                billingCurrency: validateField(
                  event.target.value,
                  'required',
                  `Billing Currency`
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                billingCurrency: validateField(
                  formData.billingCurrency.CurrencyName,
                  'required',
                  `Billing Currency`
                ),
              })
            }
          >
            <SelectOption value="" />
            {staticData.currencies?.map((field) => (
              <SelectOption
                key={field.id}
                data-label={field.CurrencyCode}
                value={`${field.CurrencyCode}:${field.CurrencyName}`}
              >
                {field.CurrencyCode + ' - ' + field.CurrencyName}
              </SelectOption>
            ))}
          </Select>
          <p className="dls-red">{formErrors.billingCurrency}</p>

          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.SUPPLIER_REGISTERED_NAME}{' '}
              <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={LABELCONST.SUPPLIER_REGISTERED_NAME}
              textValue={
                'Provide the unique business name to be used for registering the supplier in American Express Supplier Database.'
              }
            />
          </div>
          <Input
            id="supplierRegisteredName"
            maxLength={120}
            value={formData.supplierRegisteredName}
            onChange={(event) => {
              setFormErrors({
                ...formErrors,
                supplierRegisteredName: validateField(
                  event.target.value,
                  'required',
                  `Supplier Registered Name`
                ),
              });
              setFormData({
                ...formData,
                supplierRegisteredName: event.target.value,
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                supplierRegisteredName: validateField(
                  formData.supplierRegisteredName,
                  'required',
                  `Supplier Registered Name`
                ),
              })
            }
          />
          <p className="dls-red">{formErrors.supplierRegisteredName}</p>
          {isCountryChinaOrJapan(formData.billingCountry.CountryName) && (
            <div>
              <div>
                <Label className="pad-responsive-t">
                  {LABELCONST.SUPPLIER_REGISTERED_LOCAL_NAME}
                </Label>
              </div>
              <Input
                id="supplierRegisteredLocalName"
                maxLength={200}
                value={formData.supplierRegisteredLocalName}
                onChange={(event) => {
                  setFormErrors({
                    ...formErrors,
                    supplierRegisteredLocalName: validateField(
                      event.target.value,
                      'required',
                      `Supplier Registered Name in Local Language`
                    ),
                  });
                  setFormData({
                    ...formData,
                    supplierRegisteredLocalName: event.target.value,
                  });
                }}
                onBlur={() =>
                  setFormErrors({
                    ...formErrors,
                    supplierRegisteredLocalName: validateField(
                      formData.supplierRegisteredLocalName,
                      'required',
                      `Supplier Registered Name in Local Language`
                    ),
                  })
                }
              />
              <p className="dls-red">
                {formErrors.supplierRegisteredLocalName}
              </p>
            </div>
          )}

          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.SUPPLIER_REGISTERED_ADDRESS_LINE1}{' '}
              <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={LABELCONST.SUPPLIER_REGISTERED_ADDRESS_LINE1}
              textValue={
                'Provide the business address to be used for registering the supplier in American Express Supplier Database.'
              }
            />
          </div>
          <Input
            id="supplierRegisteredAddress_Line1"
            maxLength={86}
            value={formData.supplierRegisteredAddress_Line1}
            onChange={(event) => {
              setFormErrors({
                ...formErrors,
                supplierRegisteredAddress_Line1: validateField(
                  event.target.value,
                  'required',
                  `Supplier Registered Address`
                ),
              });
              setFormData({
                ...formData,
                supplierRegisteredAddress_Line1: event.target.value,
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                supplierRegisteredAddress_Line1: validateField(
                  formData.supplierRegisteredAddress_Line1,
                  'required',
                  `Supplier Registered Address`
                ),
              })
            }
          />
          <p className="dls-red">
            {formErrors.supplierRegisteredAddress_Line1}
          </p>

          <div>
            <Label className="pad-responsive-t">
              {LABELCONST.SUPPLIER_REGISTERED_ADDRESS_LINE2}{' '}
            </Label>
          </div>
          <Input
            id="supplierRegisteredAddress_Line2"
            maxLength={86}
            value={formData.supplierRegisteredAddress_Line2}
            onChange={(event) => {
              setFormData({
                ...formData,
                supplierRegisteredAddress_Line2: event.target.value,
              });
            }}
          />

          {isCountryChinaOrJapan(formData.billingCountry.CountryName) && (
            <div>
              <div>
                <Label className="pad-responsive-t">
                  {LABELCONST.SUPPLIER_REGISTERED_LOCAL_ADDRESS_LINE1}
                  <span className="dls-red">*</span>
                </Label>
              </div>
              <Input
                id="supplierRegisteredLocalAddress_Line1"
                maxLength={86}
                value={formData.supplierRegisteredLocalAddress_Line1}
                onChange={(event) =>
                  setFormData({
                    ...formData,
                    supplierRegisteredLocalAddress_Line1: event.target.value,
                  })
                }
                onKeyUp={() =>
                  validateInputs(page, setFormErrors, formData, isNextClicked)
                }
                onBlur={() =>
                  setFormErrors({
                    ...formErrors,
                    supplierRegisteredLocalAddress_Line1: validateField(
                      formData.supplierRegisteredLocalAddress_Line1,
                      'required',
                      LABELCONST.SUPPLIER_REGISTERED_LOCAL_ADDRESS_LINE1
                    ),
                  })
                }
              />
              <p className="dls-red">
                {formErrors.supplierRegisteredLocalAddress_Line1}
              </p>
            </div>
          )}
          {isCountryChinaOrJapan(formData.billingCountry.CountryName) && (
            <div>
              <div>
                <Label className="pad-responsive-t">
                  {LABELCONST.SUPPLIER_REGISTERED_LOCAL_ADDRESS_LINE2}
                </Label>
              </div>
              <Input
                id="supplierRegisteredAddress_Line2"
                maxLength={86}
                value={formData.supplierRegisteredLocalAddress_Line2}
                onChange={(event) =>
                  setFormData({
                    ...formData,
                    supplierRegisteredLocalAddress_Line2: event.target.value,
                  })
                }
              />
            </div>
          )}

          <Label className="pad-responsive-t">
            {LABELCONST.CITY} <span className="dls-red">*</span>
          </Label>
          <Input
            id="city"
            maxLength={50}
            value={formData.city}
            onChange={(event) => {
              setFormData({ ...formData, city: event.target.value });
              setFormErrors({
                ...formErrors,
                city: validateField(event.target.value, 'required', `City`),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                city: validateField(formData.city, 'required', `City`),
              })
            }
          />
          <p className="dls-red">{formErrors.city}</p>

          <Label className="pad-responsive-t">
            {LABELCONST.STATE_PROVINCE} <span className="dls-red">*</span>
          </Label>
          <Input
            id="state"
            maxLength={50}
            value={formData.state}
            onChange={(event) => {
              setFormErrors({
                ...formErrors,
                state: validateField(
                  event.target.value,
                  'required',
                  `State/Province`
                ),
              });
              setFormData({ ...formData, state: event.target.value });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                state: validateField(
                  formData.state,
                  'required',
                  `State/Province`
                ),
              })
            }
          />
          <p className="dls-red">{formErrors.state}</p>

          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.POSTAL_CODE} <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={LABELCONST.POSTAL_CODE}
              textValue={
                "Countries where postal code is not applicable mention 'NA'."
              }
            />
          </div>
          <Input
            id="postalCode"
            maxLength={50}
            value={formData.postalCode}
            onChange={(event) => {
              setFormData({
                ...formData,
                postalCode: event.target.value,
              });
              setFormErrors({
                ...formErrors,
                postalCode: validateField(
                  event.target.value,
                  'required',
                  `Postal Code`
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                postalCode: validateField(
                  formData.postalCode,
                  'required',
                  `Postal Code`
                ),
              })
            }
          />
          <p className="dls-red">{formErrors.postalCode}</p>

          <Label className="pad-responsive-t">
            {LABELCONST.COUNTRY} <span className="dls-red">*</span>
          </Label>
          <Select
            id="country"
            className="min-width-100"
            value={formData.country.CountryName}
            onChange={(event) => {
              setFormData({
                ...formData,
                country: { CountryName: event.target.value },
              });
              setFormErrors({
                ...formErrors,
                country: validateField(
                  event.target.value,
                  'required',
                  `Country`
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                country: validateField(
                  formData.country.CountryName,
                  'required',
                  `Country`
                ),
              })
            }
          >
            <SelectOption value="" />
            {staticData.countries.map((field) => (
              <SelectOption
                key={field.id}
                data-label={field.CountryCode}
                value={field.CountryName}
              >
                {field.CountryName}
              </SelectOption>
            ))}
          </Select>
          <p className="dls-red">{formErrors.country}</p>
          {formData.country.CountryName.toLowerCase() === 'other' && (
            <div>
              <Input
                id="country"
                maxLength={50}
                value={formData.otherCountryName}
                onChange={(event) => {
                  setFormErrors({
                    ...formErrors,
                    otherCountryName: validateField(
                      event.target.value,
                      'required',
                      `Other Country`
                    ),
                  });
                  setFormData({
                    ...formData,
                    otherCountryName: event.target.value,
                  });
                }}
                onBlur={() =>
                  setFormErrors({
                    ...formErrors,
                    otherCountryName: validateField(
                      formData.otherCountryName,
                      'required',
                      `Other Country`
                    ),
                  })
                }
              />
              <p className="dls-red">{formErrors.otherCountryName}</p>
            </div>
          )}
          <div className="pull-down-4">
            <Label className="pad-responsive-t">{LABELCONST.PAYEE_NAME}</Label>
            <MousePopover
              headingVal={LABELCONST.PAYEE_NAME}
              textValue={
                'Provide the billing/trading name of the supplier to be used for payment.'
              }
            />
          </div>
          <Input
            id="payeeName"
            maxLength={120}
            value={formData.payeeName}
            onChange={(event) =>
              setFormData({ ...formData, payeeName: event.target.value })
            }
          />

          {isCountryChinaOrJapan(formData.billingCountry.CountryName) && (
            <div>
              <div>
                <Label className="pad-responsive-t">
                  {LABELCONST.PAYEE_LOCAL_NAME}
                  <span className="dls-red">*</span>
                </Label>
              </div>
              <Input
                id="payeeLocalName"
                maxLength={200}
                value={formData.payeeLocalName}
                onChange={(event) =>
                  setFormData({
                    ...formData,
                    payeeLocalName: event.target.value,
                  })
                }
                onKeyUp={() =>
                  validateInputs(page, setFormErrors, formData, isNextClicked)
                }
                onBlur={() =>
                  setFormErrors({
                    ...formErrors,
                    payeeLocalName: validateField(
                      formData.payeeLocalName,
                      'required',
                      LABELCONST.PAYEE_LOCAL_NAME
                    ),
                  })
                }
              />
              <p className="dls-red">{formErrors.payeeLocalName}</p>
            </div>
          )}
          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.PAYEE_ADDRESS_LINE1}
            </Label>
            <MousePopover
              headingVal={LABELCONST.PAYEE_ADDRESS_LINE1}
              textValue={
                'Provide the billing/trading address of the supplier to be used for payment.'
              }
            />
          </div>
          <Input
            required={true}
            id="payeeAddress_Line1"
            maxLength={86}
            value={formData.payeeAddress_Line1}
            onChange={(event) =>
              setFormData({
                ...formData,
                payeeAddress_Line1: event.target.value,
              })
            }
          />

          <div>
            <Label className="pad-responsive-t">
              {LABELCONST.PAYEE_ADDRESS_LINE2}
            </Label>
          </div>
          <Input
            required={true}
            id="payeeAddress_Line2"
            maxLength={86}
            value={formData.payeeAddress_Line2}
            onChange={(event) =>
              setFormData({
                ...formData,
                payeeAddress_Line2: event.target.value,
              })
            }
          />
        </div>
        <div className="right-side">
          {isCountryChinaOrJapan(formData.billingCountry.CountryName) && (
            <div>
              <div>
                <Label className="pad-responsive-t">
                  {LABELCONST.PAYEE_ADDRESS_LOCAL_LINE1}
                </Label>
              </div>
              <Input
                id="payeeLocalAddress_Line1"
                maxLength={86}
                value={formData.payeeLocalAddress_Line1}
                onChange={(event) =>
                  setFormData({
                    ...formData,
                    payeeLocalAddress_Line1: event.target.value,
                  })
                }
                onKeyUp={() =>
                  validateInputs(page, setFormErrors, formData, isNextClicked)
                }
                onBlur={() =>
                  setFormErrors({
                    ...formErrors,
                    payeeLocalAddress_Line1: validateField(
                      formData.payeeLocalAddress_Line1,
                      'required',
                      LABELCONST.PAYEE_ADDRESS_LOCAL_LINE1
                    ),
                  })
                }
              />
              <p className="dls-red">{formErrors.payeeLocalAddress_Line1}</p>
            </div>
          )}
          {isCountryChinaOrJapan(formData.billingCountry.CountryName) && (
            <div>
              <div>
                <Label className="pad-responsive-t">
                  {LABELCONST.PAYEE_ADDRESS_LOCAL_LINE2}
                </Label>
              </div>
              <Input
                id="payeeLocalAddress_Line2"
                maxLength={86}
                value={formData.payeeLocalAddress_Line2}
                onChange={(event) =>
                  setFormData({
                    ...formData,
                    payeeLocalAddress_Line2: event.target.value,
                  })
                }
              />
            </div>
          )}
          <Label className="pad-responsive-t">{LABELCONST.PAYEE_CITY}</Label>
          <Input
            id="payeeCity"
            maxLength={50}
            value={formData.payeeCity}
            onChange={(event) => {
              setFormData({
                ...formData,
                payeeCity: event.target.value,
              }),
                setFormErrors({
                  ...formErrors,
                  payeeCity: validateField(
                    event.target.value,
                    'dashAlphanumeric',
                    `Payee City`
                  ),
                });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                payeeCity: validateField(
                  formData.payeeCity,
                  'dashAlphanumeric',
                  `Payee City`
                ),
              })
            }
          />
          <p className="dls-red">{formErrors.payeeCity}</p>
          <Label className="pad-responsive-t">
            {LABELCONST.PAYEE_STATEORPROVINCE}
          </Label>
          <Input
            id="payeeState"
            maxLength={50}
            value={formData.payeeState}
            onChange={(event) => {
              setFormData({
                ...formData,
                payeeState: event.target.value,
              });
              setFormErrors({
                ...formErrors,
                payeeState: validateField(
                  event.target.value,
                  'dashAlphanumeric',
                  `Payee State`
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                payeeState: validateField(
                  formData.payeeState,
                  'dashAlphanumeric',
                  `Payee State`
                ),
              })
            }
          />
          <p className="dls-red">{formErrors.payeeState}</p>
          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.PAYEE_POSTAL_CODE}
            </Label>
            <MousePopover
              headingVal={LABELCONST.PAYEE_POSTAL_CODE}
              textValue={
                "Countries where postal code is not applicable mention 'NA'."
              }
            />
          </div>
          <Input
            id="payeePostalCode"
            maxLength={50}
            value={formData.payeePostalCode}
            onChange={(event) => {
              setFormData({
                ...formData,
                payeePostalCode: event.target.value,
              });
              setFormErrors({
                ...formErrors,
                payeePostalCode: validateField(
                  event.target.value,
                  'dashAlphanumeric',
                  `Payee Postal Code`
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                payeePostalCode: validateField(
                  formData.payeePostalCode,
                  'dashAlphanumeric',
                  `Payee Postal Code`
                ),
              })
            }
          />
          <p className="dls-red">{formErrors.payeePostalCode}</p>
          <Label className="pad-responsive-t">{LABELCONST.PAYEE_COUNTRY}</Label>
          <Select
            id="payeeCountry"
            className="min-width-100"
            value={formData.payeeCountry.CountryName}
            onChange={(event) =>
              setFormData({
                ...formData,
                payeeCountry: { CountryName: event.target.value },
              })
            }
          >
            <SelectOption value="" />
            {staticData.countries.map((field) => (
              <SelectOption
                key={field.id}
                data-label={field.CountryCode}
                value={field.CountryName}
              >
                {field.CountryName}
              </SelectOption>
            ))}
          </Select>
          {formData.payeeCountry.CountryName.toLowerCase() === 'other' && (
            <div>
              <Input
                id="otherPayeeCountryName"
                maxLength={50}
                value={formData.otherPayeeCountryName}
                onChange={(event) => {
                  setFormErrors({
                    ...formErrors,
                    otherPayeeCountryName: validateField(
                      event.target.value,
                      'required',
                      `Other Payee Country`
                    ),
                  });
                  setFormData({
                    ...formData,
                    otherPayeeCountryName: event.target.value,
                  });
                }}
                onBlur={() =>
                  setFormErrors({
                    ...formErrors,
                    otherPayeeCountryName: validateField(
                      formData.otherPayeeCountryName,
                      'required',
                      `Other Payee Country`
                    ),
                  })
                }
              />
              <p className="dls-red">{formErrors.otherPayeeCountryName}</p>
            </div>
          )}
          <div>
            <Checkbox
              id="acknowledgementCheck"
              checked={formData.acknowledgementCheck}
              onChange={(event) => {
                setFormData({
                  ...formData,
                  acknowledgementCheck: event.target.checked,
                });
                setFormErrors({
                  ...formErrors,
                  acknowledgementCheck: event.target.checked
                    ? ''
                    : CHECKBOX_ERROR_MESSAGE,
                });
              }}
              label={
                <div>
                  <b>
                    I have read and understood the American Express® India
                    Online Privacy Statement (
                    <a
                      href="https://www.americanexpress.com/en-in/company/legal/privacy-center/online-privacy-statement/"
                      target="_blank"
                    >
                      https://www.americanexpress.com/en-in/company/legal/privacy-center/online-privacy-statement/
                    </a>
                    ), and am also aware of American Express global{' '}
                    <a
                      href="https://www.americanexpress.com/en-in/company/legal/privacy-center/privacy-principles/"
                      target="_blank"
                    >
                      Data Protection and Privacy Principles,
                    </a>{' '}
                    which sets out companies commitment to the privacy of all
                    its customers. For the purposes of being onboarded as a
                    vendor and administrating business relationship, I hereby
                    share my consent for processing of Supplier’s data, which
                    includes validation of the authenticity of information
                    shared by me (e.g. Tax ID, Banking, etc.) in the Online
                    Vendor Creation Form (OVCF).
                    <span className="dls-red">*</span>
                  </b>
                </div>
              }
            ></Checkbox>
            <p className="dls-red">{formErrors.acknowledgementCheck}</p>
          </div>

          <Label className="pad-responsive-t">
            {LABELCONST.SUPPLIER_CONTACT_PERSON}{' '}
            <span className="dls-red">*</span>
          </Label>
          <Input
            id="supplierContactPerson"
            maxLength={120}
            value={formData.supplierContactPerson}
            onChange={(event) => {
              setFormErrors({
                ...formErrors,
                supplierContactPerson: validateField(
                  event.target.value,
                  'required',
                  `Supplier's Contact Person`
                ),
              });
              setFormData({
                ...formData,
                supplierContactPerson: event.target.value,
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                supplierContactPerson: validateField(
                  formData.supplierContactPerson,
                  'required',
                  `Supplier's Contact Person`
                ),
              })
            }
          />
          <p className="dls-red">{formErrors.supplierContactPerson}</p>

          <Label className="pad-responsive-t">
            {LABELCONST.SUPPLIER_EMAIL_ADDRESS}{' '}
            <span className="dls-red">*</span>
          </Label>
          <Input
            id="supplierEmailAddress"
            maxLength={100}
            value={formData.supplierEmailAddress}
            onChange={(event) => {
              setFormData({
                ...formData,
                supplierEmailAddress: event.target.value,
              });
              setFormErrors({
                ...formErrors,
                supplierEmailAddress: validateField(
                  event.target.value,
                  'required',
                  `Supplier's Email address`
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                supplierEmailAddress: validateField(
                  formData.supplierEmailAddress,
                  'email',
                  `Supplier's`
                ),
              })
            }
          />
          <p className="dls-red">{formErrors.supplierEmailAddress}</p>

          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.SUPPLIER_PHONE_NUMBER}{' '}
              <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={LABELCONST.SUPPLIER_PHONE_NUMBER}
              textValue={
                'When entering the phone number, please do not use any special characters (-&$*^ %)'
              }
            />
          </div>
          <Input
            id="supplierPhoneNumber"
            maxLength={50}
            value={formData.supplierPhoneNumber}
            onChange={(event) => {
              setFormErrors({
                ...formErrors,
                supplierPhoneNumber: validateField(
                  event.target.value,
                  'phone',
                  `Supplier's Phone Number`
                ),
              });
              setFormData({
                ...formData,
                supplierPhoneNumber: event.target.value,
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                supplierPhoneNumber: validateField(
                  formData.supplierPhoneNumber,
                  'phone',
                  `Supplier's`
                ),
              })
            }
          />
          <p className="dls-red">{formErrors.supplierPhoneNumber}</p>

          <Label className="pad-responsive-t">
            {LABELCONST.SUPPLIER_FAX_NUMBER}
          </Label>
          <Input
            id="supplierFaxNumber"
            maxLength={50}
            value={formData.supplierFaxNumber}
            onChange={(event) =>
              setFormData({
                ...formData,
                supplierFaxNumber: event.target.value,
              })
            }
          />

          <Label className="pad-responsive-t">
            {LABELCONST.COMPANY_FINANCE_DECISION}
          </Label>
          <br />
          <span>
            If you are the key financial decision maker then please select the
            option as ‘Yes’ and provide your details below, else select the
            option as ‘No’ and share the details of the key financial decision
            maker.
          </span>
          <RadioGroup
            id="isKeyFinancialDecisionMaker"
            defaultChecked={formData.isKeyFinancialDecisionMaker}
            className="pad-responsive-t"
            onChange={(event) =>
              setFormData({
                ...formData,
                isKeyFinancialDecisionMaker: event.target.value,
              })
            }
          >
            <RadioButton id="1" label="Yes" value="Yes" />
            <RadioButton id="2" label="No" value="No" />
          </RadioGroup>
        </div>
      </div>
    </form>
  );
};

export default SupplierContactInfo;
